export const convertToCurrency = (value: number): string | undefined => {
    if (!value) {
        return undefined;
    }

    return new Intl.NumberFormat('en-NZ', { style: 'currency', currency: 'NZD' }).format(value);
}

